import React, { useState } from 'react'
import './topbar.css'
import profile from '../../assets/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import { toggleMessage, 
    toggleNotification, toggleSettings, toggleSideBar } from '../../state/settingsSlice'
import { Link } from 'react-router-dom'
import { userLogout } from '../../state/userSlice'
import { IoIosArrowDown } from "react-icons/io";

// PROFILE BOX
const TopbarDropDown = ({setDropDown, handleLogout}) => {

    return(
        <div className='topbar__dropdown' 
        onClick={()=>setDropDown(false)}>
            <div onClick={(e)=>e.stopPropagation()}
            className="topbar__dropdown-content">
                <Link to={'/profile'} 
                className='topbar__dropdown-link'>
                    Profile
                </Link>
                <Link onClick={handleLogout}
                className='topbar__dropdown-link'>
                    Logout
                </Link>
            </div>
        </div>
    )
}

const Topbar = ({message}) => {
    const dispatch = useDispatch()
    const {sidebar, notification, 
        notifyMessage, settings} = useSelector((state)=>state.settings)
    const {user, notifications} = useSelector((state)=>state.user)
    const [dropDown, setDropDown] = useState(false)

    const handleNotification = () => {
        dispatch(toggleNotification(!notification))
    }

    const handleMessage = () => {
        dispatch(toggleMessage(!notifyMessage))
    }

    const handleSettings = () => {
        dispatch(toggleSettings(!settings))
    }

    const handleSidebar = () =>{
        dispatch(toggleSideBar(!sidebar))
    }

    const handleLogout = () =>{
        dispatch(userLogout())
    }

    const filterNotification = notifications?.filter((item)=>{
        return item?.user !== user?._id
    })

  return (
    <div className={`topbar ${!sidebar && 'active'}`}>
        <div className="topbar__content">
            {!sidebar && <button className="topbar__button toggle" 
            onClick={handleSidebar}>
                <i className='bx bx-menu topbar__button-icon'></i>
            </button>}
            
            <div className="topbar__list">
                <div className="topbar__list-buttons">
                    <button className="topbar__button"
                    onClick={handleNotification}>
                        <i className='bx bx-bell topbar__button-icon'></i>
                        {filterNotification?.length > 0 && <span className="topbar__button-count">
                            {filterNotification?.length}
                        </span>}
                    </button>
                    
                    <button className="topbar__button"
                    onClick={handleMessage}>
                        <i className='bx bx-chat topbar__button-icon'></i>
                        {message?.length > 0 && <span className="topbar__button-count">
                            {message?.length}
                        </span>}
                    </button>

                    <button className="topbar__button set"
                    onClick={handleSettings}>
                        <i className={`bx bx-cog topbar__button-icon`}></i>
                    </button>
                </div>
                <div onClick={()=>setDropDown(!dropDown)}
                className="topbar__list-profile">
                    <img src={!user?.profilePic ? profile 
                    : `https://backend.aspomportal.com/upload/${user?.profilePic}`} 
                    alt={user?.firstName}
                    className="topbar__profile-img" />
                    <div className="topbar__profile-detail">
                        <p className="topbar__profile-name">
                            <strong>{user?.lastName}</strong>
                        </p>
                        <span className="topbar__profile-role">
                            {user?.department ? user?.department : '' } {' '} {user?.role}
                        </span>
                    </div>
                    <IoIosArrowDown/>
                </div>
            </div>
        </div>
        {dropDown && <TopbarDropDown setDropDown={setDropDown}
        handleLogout={handleLogout}/>}
        
    </div>
  )
}

export default Topbar